export class User {
    constructor(
        public id:string = '',
        public full_name :string = '',
        public user_name:string = '',
        public picture:string = '',
        public role:string = ''
    ) {}

    static fromJson(json:any) {
        return new User(
            json.d.USER_ID,
            json.d.FULL_NAME,
            json.d.USER_NAME,
            json.d.PICTURE,
            json.d.PRIMARY_ROLE_NAME
        );
    }

}


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/app/models/Users.ts